import { Clock } from 'lucide-react';
import { Card, IconBox } from '@/ui/primitives';

// Placeholder honesto: o legado também não implementou histórico.
// Quando o back-end expor /api/v2/clientes/{cpf}/historico, plugar aqui.
export function ClienteHistoricoTab() {
  return (
    <Card padding="lg">
      <div className="flex items-start gap-3">
        <IconBox tone="neutral" size="md">
          <Clock size={14} strokeWidth={1.5} />
        </IconBox>
        <div className="flex flex-col gap-1 min-w-0">
          <span className="text-sm font-medium text-text">
            Histórico em construção
          </span>
          <span className="text-xs text-text-2">
            Linha do tempo de eventos do cliente (atualizações, processos, varreduras de
            diagnóstico) — disponível quando o endpoint{' '}
            <code className="text-[11px] font-mono">/api/v2/clientes/{`{cpf}`}/historico</code>{' '}
            for exposto pelo back-end.
          </span>
        </div>
      </div>
    </Card>
  );
}
